function getErrResponseData(err) {
  return err.response?.data;
}

function getErrorCode(err) {
  return getErrResponseData(err)?.error?.error_code;
}

function getErrorMessage(err) {
  return getErrResponseData(err)?.error?.message || getErrResponseData(err)?.error?.original_message
}

function isPhoneInvalid(err) {
  return typeof getErrResponseData(err)?.errors?.phone?.[0] === 'string';
}

function getCooldownTime(err, defaultVal=60) {
  return getErrResponseData(err)?.error?.meta?.cooldown || defaultVal;
}

function getTranslatedErrorMessage(err) {
  const error = getErrResponseData(err)?.error

  if (!error || !error.message || !error.original_message || error.message !== error.original_message) {
    return null
  }

  return error.message
}

export {
  getErrResponseData,
  getErrorCode,
  isPhoneInvalid,
  getCooldownTime,
  getTranslatedErrorMessage,
  getErrorMessage,
};
